export default (msg) => {
    if (msg === '') return false;

    return true;
};
